import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import * as logger from "../../../logger";
import {
    InputBase,
    Paper,
    Grid,
    InputAdornment
} from '@material-ui/core';
import { InvoiceHomeCss } from './InvoiceCss';
import Wrapper from '../../components/Wrapper/Wrapper';
import TopCard from '../../components/TopCard/TopCard'
import MUIDataTable from "mui-datatables";
import { getInvoiceList, getSingleInvoice } from '../../../store/actions/tripActionCreator';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { numberFormat, vehicleNumberValidation, getDateInStringDDMMMYYYY, getDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils'
import SearchIcon from '@material-ui/icons/Search';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Highlighter from "react-highlight-words";
import { trackDwebEvent } from '../../analytics';
import InvoiceStatusFilter from '../../components/FilterComponent/InvoiceStatusFilter';
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import { Waypoint } from "react-waypoint";

const Invoice = ({ user, trip, dispatchGetInvoiceList, dispatchGetSingleInvoice }) => {

    const classes = InvoiceHomeCss();
    let history = useHistory();

    const [invoiceListData, setInvoiceListData] = useState({});
    const [searchText, setSearchText] = useState("");
    const [invoiceStatusInfo, setInvoiceStatusInfo] = useState("all");
    const [changeFlag, setChangeFlag] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
    const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
    const [loadingText, setLoadingText] = useState("Sorry, no Invoices found");


    const invoiceReqData = {
        pageNo: defaultPageNo,
        pageSize: defaultPageSize,
        searchText: searchText
    };

    useEffect(() => {

        setLoadingText("Loading........");
        invoiceListData.invoices = [];

        const invoiceReqData = {
            pageNo: defaultPageNo,
            pageSize: defaultPageSize,
            searchText: searchText
        };

        setCurrentPageNo(defaultPageNo);

        dispatchGetInvoiceList(invoiceReqData, invoiceStatusInfo,
            (data) => {
                setLoadingText("Sorry, no Invoices found");
                if (data && data.status && data.status.code == 200) {
                    logger.log('Invoice Dweb', 'Get Invoice List Successfull');
                    const invoiceListInfo = data.response;
                    if (data.response) {
                        if (invoiceStatusInfo == "paid") {
                            trackDwebEvent('Dweb Invoice listing filter changed to Paid Invoices', {
                                count_of_invoices: invoiceListInfo && invoiceListInfo.totalInvoiceCount ? invoiceListInfo.totalInvoiceCount : 0,
                                count_of_unpaid_invoices: invoiceListInfo && invoiceListInfo.unpaidInvoiceCount ? invoiceListInfo.unpaidInvoiceCount : 0,
                                count_of_paid_invoices: invoiceListInfo && invoiceListInfo.paidInvoiceCount ? invoiceListInfo.paidInvoiceCount : 0
                            })
                        } else if (invoiceStatusInfo == "unpaid") {
                            trackDwebEvent('Dweb Invoice listing filter changed to UnPaid Invoices', {
                                count_of_invoices: invoiceListInfo && invoiceListInfo.totalInvoiceCount ? invoiceListInfo.totalInvoiceCount : 0,
                                count_of_unpaid_invoices: invoiceListInfo && invoiceListInfo.unpaidInvoiceCount ? invoiceListInfo.unpaidInvoiceCount : 0,
                                count_of_paid_invoices: invoiceListInfo && invoiceListInfo.paidInvoiceCount ? invoiceListInfo.paidInvoiceCount : 0
                            })
                        }
                    }
                }
            },
            () => {
                setLoadingText("Sorry, no Invoices found");
                logger.log('Invoice Dweb', 'Get Invoice List Failed');
            }
        );

    }, [invoiceStatusInfo]);

    useEffect(() => {

        if (trip && trip.invoiceLedgerData) {
            setInvoiceListData(trip.invoiceLedgerData);
        }

    }, [trip.invoiceLedgerData]);

    useEffect(() => {

        const invoiceLedger = trip.invoiceLedgerData ? trip.invoiceLedgerData : null;

        if (invoiceLedger) {
            trackDwebEvent('Dweb Invoice listing page', {
                count_of_invoices: invoiceLedger && invoiceLedger.totalInvoiceCount ? invoiceLedger.totalInvoiceCount : 0,
                count_of_unpaid_invoices: invoiceLedger && invoiceLedger.unpaidInvoiceCount ? invoiceLedger.unpaidInvoiceCount : 0,
                count_of_paid_invoices: invoiceLedger && invoiceLedger.paidInvoiceCount ? invoiceLedger.paidInvoiceCount : 0
            })
        }

    }, []);

    const onSearchBlur = debounce(query => {
        invoiceListData.invoices = [];
        setLoadingText("Loading........");
        setCurrentPageNo(defaultPageNo);
        dispatchGetInvoiceList({ ...invoiceReqData, searchText: query }, invoiceStatusInfo,
            () => {
                setLoadingText("Sorry, no Invoices found");
            },
            () => {
                setLoadingText("Sorry, no Invoices found");
            }
        )
    }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);

    const muiColumns = [
        {
            name: "invoiceDate",
            label: "Invoice Date",
            options: {
                filter: false,
                sort: true,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    // return <span className={classes.fwNormal}>{getDateInStringDDMMMYYYY(value)}</span>

                    let data = muiData[dataIndex];
                    if (rowIndex === muiData.length - 3) {
                        return (
                            <>
                                <Waypoint
                                    onEnter={() => {
                                        if (currentPageNo < invoiceListData.maxPage) {
                                            getPaginatedData()
                                            setCurrentPageNo(currentPageNo + 1)
                                        }
                                    }}
                                />
                                <div className={classes.fwNormal}>
                                    {getDateInStringDDMMMYYYY(data.invoiceDate)}
                                </div>
                            </>
                        );
                    } else {
                        return (
                            <>
                                <div className={classes.fwNormal}>
                                    {getDateInStringDDMMMYYYY(data.invoiceDate)}
                                </div>
                            </>
                        )
                    }

                }
            },

        },
        {
            name: "invoiceNumber",
            label: "Invoice No",
            options: {
                filter: true,
                sort: false,
                searchable: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (

                        <span>
                            <Highlighter
                                highlightClassName={classes.highlight}
                                searchWords={[searchText]}
                                autoEscape={true}
                                textToHighlight={value ? value : ""}
                            />
                        </span>
                    )
                }
            },
        },
        {
            name: "customerName",
            label: "Party",
            options: {
                filter: true,
                sort: false,
                searchable: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <span className={classes.fwNormal}>
                            <Highlighter
                                highlightClassName={classes.highlight}
                                searchWords={[searchText]}
                                autoEscape={true}
                                textToHighlight={value ? value : ""}
                            />
                        </span>
                    )
                }
            },
        },
        {
            name: "dueStatus",
            label: "Due Status",
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = invoiceListData && invoiceListData.invoices && invoiceListData.invoices[dataIndex] ? invoiceListData.invoices[dataIndex] : {}
                    return (
                        <>
                            {rowData && rowData.dueStatus &&
                                <div className={classes["dueStatus" + rowData.dueStatus]}>
                                    <span className={classes.fwNormal}>{rowData.dueStatus ? rowData.dueStatus : "--"}</span>
                                </div>
                            }
                            {rowData && !rowData.dueStatus &&
                                <div className={classes.dueStatusPaid}>
                                    <span className={classes.fwNormal}>{rowData.invoiceStatus ? rowData.invoiceStatus : "--"}</span>
                                </div>
                            }
                        </>
                    )
                }
            },
        },
        {
            name: "invoiceAmount",
            label: "Invoice Amount",
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div className={classes.invoiceAmount}>{numberFormat(Number(value))}</div>
                },
                customHeadRender: (columnMeta) => (
                    <th key={5} className={classes.thTruckRightAlign}>
                        {columnMeta.label}
                    </th>
                )
            },
        },
        {
            name: "balanceAmount",
            label: "Balance",
            options: {
                filter: false,
                sort: false,
                searchable: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div className={classes.divAlign}><div className={value == 0 ? classes.balanceAmountGrey : classes.balanceAmount}>{numberFormat(Number(value))}</div><ChevronRightIcon className={classes.rightIcon} /></div>
                },
                customHeadRender: (columnMeta) => (
                    <th key={5} className={classes.thTruckRightAlignV1}>
                        {columnMeta.label}
                    </th>
                )
            },
        }
    ];

    const muiData = invoiceListData && invoiceListData.invoices ? invoiceListData.invoices : [];
    const options = {
        rowsPerPage: 100,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tableHeightWithSparkline,
        selectableRows: 'none',
        searchOpen: true,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        pagination: false,
        customToolbar: (data) => {
            return <>
                <div className={classes.divFilter}>
                    <div>
                        {/* <div className={classes.divInvoiceStatus}>Invoice Status</div> */}
                        <InvoiceStatusFilter status={handleStatusChange} />
                    </div>
                </div>
            </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        onRowClick: (rowData, rowMeta) => {
            goToSingleInvoice(muiData[rowMeta.dataIndex]);
        },
        searchProps: {
            variant: "outlined",
            // value: searchText,
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search for Invoice No or Party',
        onSearchChange: (val) => {
            trackDwebEvent('Dweb Invoice searched', {
                search_string: val
            });
            let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
            setSearchText(value);
            if (value && value.length > 1) {
                onSearchBlur(value)
            } else if (searchText && value && value.trim().length <= 1) {
                setSearchText("");
                onSearchBlur("")
            }else{
                setSearchText("");
                onSearchBlur("")
            }
        },
        onSearchClose: () => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
            let isFound = false;
            /*if (searchQuery && searchQuery.trim().length > 0) {
                searchQuery = searchQuery.trim()
                currentRow.forEach(col => {
                    if (col && col.toString().toUpperCase().indexOf(searchQuery.toUpperCase()) >= 0) {
                        isFound = true;
                    }
                });
            } else {
                isFound = true;
            }*/
            return true;
        },
        onColumnSortChange: (changedColumn, direction) => {
            trackDwebEvent('Dweb Invoice sorted ', {
                sorting_order: direction
            })
        },
        textLabels: {
            body: {
                noMatch: loadingText,
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };

    const getPaginatedData = () => {
        const invoiceReqData = {
            pageNo: currentPageNo + 1,
            pageSize: currentPageSize,
            searchText: searchText,
            merge: true
        };

        dispatchGetInvoiceList(invoiceReqData, invoiceStatusInfo,
            () => {
            },
            () => {
            }
        )
    }

    const goToSingleInvoice = (invoice) => {

        history.push({
            pathname: `/invoices/single-invoice/${invoice && invoice.id ? invoice.id : ""}`,
            state: {
                id: 7,
                pageTitle: invoice && invoice.invoiceNumber ? invoice.invoiceNumber : "",
                pageSubTitle: invoice && invoice.dueStatus ? invoice.dueStatus : "",
                invoiceId: invoice && invoice.id ? invoice.id : ""
            }
        });

    }

    const handleStatusChange = (status) => {
        setInvoiceStatusInfo(status);
        setChangeFlag(true);
    }

    return (
        <Wrapper>
            <Paper className={classes.pageContentDiv} elevation={3}>
                {invoiceListData && invoiceListData.totalInvoiceCount && invoiceListData.totalInvoiceCount > 0 ?
                    <>
                        <Grid container justify="flex-start" spacing={3} direction="row" alignItems="center">
                            <Grid item>
                                <TopCard title='ALL INVOICES' color="#0b1323" infoIcon={false} cardValue={invoiceListData && invoiceListData.totalInvoiceCount ? invoiceListData.totalInvoiceCount : 0} />
                            </Grid>
                            <Grid item>
                                <TopCard title='PAID INVOICES' color="#079627" infoIcon={false} cardValue={invoiceListData && invoiceListData.paidInvoiceCount ? invoiceListData.paidInvoiceCount : 0} />
                            </Grid>
                            <Grid item>
                                <TopCard title='UNPAID INVOICES' color="#ff0000" infoIcon={false} cardValue={invoiceListData && invoiceListData.unpaidInvoiceCount ? invoiceListData.unpaidInvoiceCount : 0} />
                            </Grid>
                        </Grid>
                        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                    </>
                    :
                    <>
                        <div className={classes.titlePreview}>Preview</div>
                        <div className={classes.divEmpty} >
                            <img src={`${process.env.PUBLIC_URL}/assets/images/invoice-empty-1.png`} className={classes.imgV1} />
                            <img src={`${process.env.PUBLIC_URL}/assets/images/invoice-empty-2.png`} className={classes.imgV2} />
                        </div>
                    </>
                }

            </Paper>
        </Wrapper>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetInvoiceList: (invoiceReqData, invoiceStatusInfo, onSuccess, onError) => {
        dispatch(getInvoiceList(invoiceReqData, invoiceStatusInfo, onSuccess, onError))
    },
    dispatchGetSingleInvoice: (invoiceId, onSuccess, onFailure) => {
        dispatch(getSingleInvoice(invoiceId, onSuccess, onFailure))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Invoice);
